/* eslint-disable no-lone-blocks */
/* eslint-disable react/jsx-first-prop-new-line */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { ContainerInput } from './styles';
import Api, {
  getListSellerSubjectItems,
  getSellersCourse,
} from '../../../services/api';
import { insertTemporaryLink } from '../../../services/temporaryLinkService';
import { exportToExcel, exportToExcelCourseData } from '../../ExportXlsx';

interface IAlertConfirm {
  title: string;
  text?: string;
  type?: string;
  lmsKey?: string;
  subjectId?: string;
  courseId?: string;
}

interface ITemporaryLink {
  lms_key: string;
  item_id?: string;
  expiration_date: string;
  link: string;
}

const AlertConfirm = async ({
  title,
  text,
  type,
  lmsKey,
  subjectId,
  courseId,
}: IAlertConfirm) => {
  const MySwal = withReactContent(Swal);
  if (type === 'reproved' || type === 'adjust') {
    const result = await MySwal.fire({
      title: <p>{title}</p>,
      text: `${text}, adicione um comentário:`,
      input: 'text',
      showCancelButton: true,
      confirmButtonColor: '#6BC196',
      cancelButtonColor: '#CC593E',
      confirmButtonText: 'SIM',
      cancelButtonText: 'NÃO',
    });
    if (result.value) {
      return result.value;
    }
    if (result.value === true) {
      return ' ';
    }
  } else if (type === 'lms') {
    const result = await MySwal.fire({
      title: <p>{title}</p>,
      text,
    });
    if (result.value) {
      return result.value;
    }
    if (result.value === true) {
      return ' ';
    }
  } else if (type === 'shareLink') {
    if (!lmsKey) {
      return null;
    }

    const lmsKeyFormatted = lmsKey.replace(/['"]+/g, '');

    let url = 'https://student.aurea.app';
    if (process.env.REACT_APP_API === 'https://api-staging.aurea.app') {
      url = 'https://student-staging.aurea.app';
    }
    let studentIdDefault = '<EMAIL/RA/IDENTIFICADOR>';

    // Fanorpi
    if (lmsKeyFormatted === '3f6a963ca5a77d85cc13fc265db61b0e') {
      studentIdDefault = '<userEmail>';
    }

    // ESIC
    if (lmsKeyFormatted === 'ea3bca20e6fb6d7890482f5f8c50112b') {
      url = 'https://lti.aurea.app';

      const urlLtiToCanvas = await MySwal.fire({
        title: <>{title}</>,
        html: (
          <a href=" " target="__blank">
            {`${url}/itemId=${subjectId}`}
          </a>
        ),
        confirmButtonText: 'Copiar URL',
        showCancelButton: true,
        denyButtonText: 'OK',
      });

      if (urlLtiToCanvas.isConfirmed) {
        const copyUrl = () => {
          const linkToCopy = `${url}/itemId=${subjectId}`;
          navigator.clipboard.writeText(linkToCopy);
          return url;
        };

        return copyUrl();
      }

      if (urlLtiToCanvas.value) {
        return urlLtiToCanvas.value;
      }
      if (urlLtiToCanvas.value === true) {
        return ' ';
      }
      return;
    }

    const result = await MySwal.fire({
      title: <p>{title}</p>,
      html: (
        <a
          href={`${url}/validation/post?lmsKey=${lmsKeyFormatted}&itemId=${subjectId}&studentId=${studentIdDefault}`}
          target="__blank"
        >
          {`${url}/validation/post?lmsKey=${lmsKeyFormatted}&itemId=${subjectId}&studentId=${studentIdDefault}`}
        </a>
      ),
    });

    if (result.value) {
      return result.value;
    }
    if (result.value === true) {
      return ' ';
    }
  } else if (type === 'shareTemporaryLink') {
    if (!lmsKey) {
      return null;
    }
    let url = 'https://student.aurea.app';
    if (process.env.REACT_APP_API === 'https://api-staging.aurea.app') {
      url = 'https://student-staging.aurea.app';
    }
    const { data: allSellers } = await Api.get('/sellers/');

    const currentUser = localStorage.getItem('@aurea:user');
    const currentLmsKey = currentUser
      ? JSON.parse(currentUser).seller.lms_key
      : '';

    console.log('currentSellerId', currentLmsKey);

    await MySwal.fire({
      title: 'Criar Link Temporário',

      html: (
        <ContainerInput>
          <label htmlFor="date">Data de expiração:</label>
          <input type="date" id="date" />
          <select name="seller" id="seller" defaultValue={currentLmsKey || ''}>
            {allSellers.map(seller => (
              <option key={seller.lms_key} value={seller.lms_key}>
                {seller.name}
              </option>
            ))}
          </select>
        </ContainerInput>
      ),
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Criar Link',
      showLoaderOnConfirm: true,
      // if date is true then create link
      preConfirm: async () => {
        const expireDate = document.getElementById('date') as HTMLInputElement;
        const lmsKeySellerBySelect = document.getElementById(
          'seller',
        ) as HTMLSelectElement;

        if (
          expireDate.value &&
          expireDate.value !== '' &&
          lmsKeySellerBySelect.value
        ) {
          const urlCreated = `${url}/validation/post?lmsKey=${lmsKeySellerBySelect.value}&itemId=${subjectId}&expirationDate=${expireDate.value}`;
          const temporaryLink: ITemporaryLink = {
            lms_key: lmsKeySellerBySelect.value,
            item_id: subjectId,
            expiration_date: expireDate.value,
            link: urlCreated,
          };
          await insertTemporaryLink(temporaryLink);

          return urlCreated;
        }
        MySwal.showValidationMessage('Preencha a data de expiração');
      },
    }).then(result => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: 'Link a ser compartilhado',
          html: (
            <a href={result.value} target="_blank" rel="noreferrer">
              {result.value}
            </a>
          ),
        });
      }
    });
  } else if (type === 'shareTemporaryLinkToSubject') {
    if (!lmsKey) {
      return null;
    }
    let url = 'https://student.aurea.app';
    if (process.env.REACT_APP_API === 'https://api-staging.aurea.app') {
      url = 'https://student-staging.aurea.app';
    }
    const { data: allSellers } = await Api.get('/sellers/');
    if (!subjectId) {
      console.error('subjectId is required for creating a temporary link');
      return;
    }
    const { data: subjectData } = await getListSellerSubjectItems(subjectId);
    if (!subjectData || subjectData.length === 0) {
      console.error('No items found for the given subjectId');
      return;
    }
    const { subjectItems, subject } = subjectData;
    const subjectName = subject.name;

    console.log('items', subjectItems);

    const currentUser = localStorage.getItem('@aurea:user');
    const currentLmsKey = currentUser
      ? JSON.parse(currentUser).seller.lms_key
      : '';

    console.log('currentSellerId', currentLmsKey);

    await MySwal.fire({
      title: 'Criar Link Temporário',

      html: (
        <ContainerInput>
          <label htmlFor="date">Data de expiração:</label>
          <input type="date" id="date" />
          <select name="seller" id="seller" defaultValue={currentLmsKey || ''}>
            {allSellers.map(seller => (
              <option key={seller.lms_key} value={seller.lms_key}>
                {seller.name}
              </option>
            ))}
          </select>
        </ContainerInput>
      ),
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Criar Link',
      showLoaderOnConfirm: true,
      // if date is true then create link
      preConfirm: async () => {
        const expireDate = document.getElementById('date') as HTMLInputElement;
        const lmsKeySellerBySelect = document.getElementById(
          'seller',
        ) as HTMLSelectElement;

        if (
          expireDate.value &&
          expireDate.value !== '' &&
          lmsKeySellerBySelect.value
        ) {
          const dataToCreateFile: object[] = [];

          const promises = subjectItems.map(subjectItem => {
            const { itemId } = subjectItem;
            const urlCreated = `${url}/validation/post?lmsKey=${lmsKeySellerBySelect.value}&itemId=${itemId}&expirationDate=${expireDate.value}`;

            const dataToInsert = {
              itemName: subjectItem.title,
              itemId,
              url: urlCreated,
            };
            dataToCreateFile.push(dataToInsert);

            const temporaryLink = {
              lms_key: lmsKeySellerBySelect.value,
              item_id: itemId,
              expiration_date: expireDate.value,
              link: urlCreated,
            };

            return insertTemporaryLink(temporaryLink);
          });

          await Promise.all(promises);
          return dataToCreateFile;
        }
        MySwal.showValidationMessage('Preencha a data de expiração');
      },
    }).then(result => {
      if (result.isConfirmed) {
        exportToExcel(result.value, subjectName);

        MySwal.fire({
          title: 'Arquivo gerado com sucesso!',
          text: 'Seu Excel foi baixado.',
          icon: 'success',
        });
      }
    });
  } else if (type === 'shareTemporaryLinkToCourse') {
    if (!lmsKey) {
      return null;
    }
    let url = 'https://student.aurea.app';
    if (process.env.REACT_APP_API === 'https://api-staging.aurea.app') {
      url = 'https://student-staging.aurea.app';
    }
    const { data: allSellers } = await Api.get('/sellers/');
    if (!courseId) {
      console.error('courseId is required for creating a temporary link');
      return;
    }
    const { data: courseData } = await getSellersCourse(courseId);
    if (
      !courseData ||
      !courseData.courseItems ||
      courseData.courseItems.length === 0
    ) {
      console.error('No items found for the given courseId');
      return;
    }
    const { courseItems: subjects, name: courseName } = courseData;

    console.log('course items', subjects);

    const currentUser = localStorage.getItem('@aurea:user');
    const currentLmsKey = currentUser
      ? JSON.parse(currentUser).seller.lms_key
      : '';

    console.log('currentSellerId', currentLmsKey);

    await MySwal.fire({
      title: 'Criar Link Temporário',

      html: (
        <ContainerInput>
          <label htmlFor="date">Data de expiração:</label>
          <input type="date" id="date" />
          <select name="seller" id="seller" defaultValue={currentLmsKey || ''}>
            {allSellers.map(seller => (
              <option key={seller.lms_key} value={seller.lms_key}>
                {seller.name}
              </option>
            ))}
          </select>
        </ContainerInput>
      ),
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Criar Link',
      showLoaderOnConfirm: true,
      // if date is true then create link
      preConfirm: async () => {
        const expireDate = document.getElementById('date') as HTMLInputElement;
        const lmsKeySellerBySelect = document.getElementById(
          'seller',
        ) as HTMLSelectElement;

        if (
          expireDate.value &&
          expireDate.value !== '' &&
          lmsKeySellerBySelect.value
        ) {
          const processedCourseData: any[] = [];

          // Para cada disciplina do curso, buscar seus itens
          const promises = subjects.map(async subject => {
            const { subjectId: courseSubjectId } = subject;

            try {
              // Buscar os itens da disciplina
              const { data: subjectData } = await getListSellerSubjectItems(
                courseSubjectId,
              );

              if (subjectData && subjectData.subjectItems) {
                const subjectItems = subjectData.subjectItems.map(
                  (item: any) => {
                    const urlCreated = `${url}/validation/post?lmsKey=${lmsKeySellerBySelect.value}&itemId=${item.itemId}&expirationDate=${expireDate.value}`;

                    const temporaryLink = {
                      lms_key: lmsKeySellerBySelect.value,
                      item_id: item.itemId,
                      expiration_date: expireDate.value,
                      link: urlCreated,
                    };

                    return {
                      itemName: item.title,
                      name: item.title,
                      url: urlCreated,
                    };
                  },
                );

                // Criar links temporários
                const linkPromises = subjectData.subjectItems.map(
                  (item: any) => {
                    const urlCreated = `${url}/validation/post?lmsKey=${lmsKeySellerBySelect.value}&itemId=${item.itemId}&expirationDate=${expireDate.value}`;

                    const temporaryLink = {
                      lms_key: lmsKeySellerBySelect.value,
                      item_id: item.itemId,
                      expiration_date: expireDate.value,
                      link: urlCreated,
                    };

                    return insertTemporaryLink(temporaryLink);
                  },
                );

                await Promise.all(linkPromises);

                return {
                  subjectId: courseSubjectId,
                  subjectName:
                    subjectData.subject?.name ||
                    `Disciplina ${courseSubjectId}`,
                  items: subjectItems,
                };
              }
            } catch (error) {
              console.error(
                `Erro ao buscar itens da disciplina ${courseSubjectId}:`,
                error,
              );
              return {
                subjectId: courseSubjectId,
                subjectName: `Disciplina ${courseSubjectId}`,
                items: [],
              };
            }
          });

          const results = await Promise.all(promises);
          processedCourseData.push(...results);

          return processedCourseData;
        }
        MySwal.showValidationMessage('Preencha a data de expiração');
      },
    }).then(result => {
      if (result.isConfirmed) {
        exportToExcelCourseData(result.value, courseName);

        MySwal.fire({
          title: 'Arquivo gerado com sucesso!',
          text: 'Seu Excel foi baixado.',
          icon: 'success',
        });
      }
    });
  } else {
    const result = await MySwal.fire({
      title: <p>{title}</p>,
      text,
      showCancelButton: true,
      confirmButtonColor: '#6BC196',
      cancelButtonColor: '#CC593E',
      confirmButtonText: 'SIM',
      cancelButtonText: 'NÃO',
    });
    if (result.value) {
      return result.value;
    }
    if (result.value === true) {
      return ' ';
    }
  }
  return false;
};

export default AlertConfirm;
